import React from 'react';
import { observer } from 'mobx-react';

import {
  HeaderMarginTop as Main,
  MainWrapper,
} from 'legacyComponents/styled/lib';
import {
  AvatarIndicator,
  TitleIndicator,
  InfoIndicator,
  Article,
} from 'apps/story/styles';

export const StoryIndicator = observer(() => (
  <Main>
    <MainWrapper>
      <AvatarIndicator />
    </MainWrapper>
    <Article>
      <TitleIndicator />
      <InfoIndicator />
    </Article>
  </Main>
));
